<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <mat-stepper
      #linearVerticalStepper="matVerticalStepper"
      formArrayName="pledgeOwners"
      [linear]="true"
      (selectionChange)="stepClick($event)"
    >
      @for (
        pledgeOwner of pledgeOwners.controls;
        track pledgeOwner;
        let i = $index
      ) {
        <mat-step
          [formGroup]="pledgeOwner"
          [stepControl]="pledgeOwners?.get([i])"
          completed="false"
        >
          <ng-container formGroupName="antiMoneyLaundering">
            <ng-template matStepLabel>{{
              pledgeOwner?.get('userFirstName')?.value +
                ' ' +
                pledgeOwner?.get('userLastName')?.value
            }}</ng-template>
            <mat-accordion class="example-headers-align">
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Risque client - Personne physique
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="adresseDomiciliation"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Adresse de domiciliation"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Utilisation d'une adresse de domiciliation."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="fortuneInfluent"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Très fortuné et influent"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Client très fortuné et influent ayant une grande notoriété publique."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="secteurRisqueCorruption"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Secteur avec risque de corruption"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Client exercant dans des secteurs communément associés à un risque de corruption ou de blanchiment plus élevé."
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="discretionInhabituelle"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Niveau de discrétion inhabituelle"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Client qui exige un niveau de confidentialité ou de discrétion inhabituellement élevé."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="ppe"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Client PPE"
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Le client est une PPE (art. L561-10 et R561-18 du CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="personneListeGelsDesAvoirs"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Personne physique sur la liste des gels des avoirs ?"
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Personnes physiques inscrites sur la liste de Gel des Avoirs."
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="fondListeGelsDesAvoirs"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Fond provenant d’une personne physique sur la liste des gels des avoirs ?"
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Personnes physiques inscrites sur la liste de Gel des Avoirs."
                    />
                  </div>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title> Risques produits </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="versementPeePerco"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Versement PEE ou PERCO >8000€ ou versement par un tiers"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Sommes versées sur un PEE ou un PERCO, à l'exception des versements volontaires qui dépassent 8.000 euros ou qui ne sont pas effectués à partir d'un compte ouvert au nom du bénéficiaire ou de son employeur (art. R561-16 7° et 8° du CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="produitsAtypiques"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Produits atypiques"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Produits atypiques / fonds ne faisant pas appel public à l'épargne (autres FIA, parts sociales, biens divers, etc.)"
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="controleActifsFonds"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Contrôle sur les actifs du fonds"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Les investisseurs exercent un contrôle sur les actifs du fonds."
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="compteTitreAugmentationCapital"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Compte titre pour augmentation de capital >15000€"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Comptes-titres aux fins de bénéficier d'une augmentation de capital réservée, d'actions gratuites, d'options de souscription ou d'achat d'actions et qui ne dépassent pas une valeur de 15.000 euros (art. R561-16 9° du CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="primeAnnuelleUnique"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Prime annuelle >1000€ ou prime unique >2500€"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Prime annuelle supérieure à 1.000 € ou prime unique supérieure à 2.500 € versée sur un contrat d’assurance vie ou de capitalisation (art. R561-16 1° du CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="contratPrevoyanceSante"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Contrat prévoyance ou santé"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Contrats de prévoyance collective ou individuelle ; complémentaires santé et accident (art. R561-16 2° du CMF)"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="assuranceEmprunteur"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Assurance emprunteur"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Contrats d'assurance emprunteur (art. R561-16 4° du CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="contratAssuranceSansClauseRachat"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Contrat d'assurance retraite sans clause de rachat"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Contrat d'assurance retraite qui ne comportent pas de clause de rachat (art. R561-16 3° du CMF) tels que les PERP, loi 'Madelin', PERE, 'article 83' et 'article 39'"
                    />
                  </div>
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="contratAnonyme"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Contrat anonyme"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Contrat favorisant l'anonymat (art. L561-10 du CMF) : bon ou contrat de capitalisation anonyme."
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-4 d-flex gap-1">
                    <pr-input-radio
                      formControlName="produitsImmobiliersLuxe"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Produits immobiliers de luxe"
                    >
                    </pr-input-radio>
                    <pr-tooltip-icon
                      tooltip="Biens résidentiels de luxe et de prestige, particulièrement à Paris, sur la Côte d’Azur et dans les départements et collectivités d’Outre-mer."
                    />
                  </div>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title> Risques pays </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                  <div class="col-xs-12 col-md-6 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="operationPaysGafi"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Opération avec pays liste GAFI"
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Opération pour compte propre ou pour compte de tiers effectuée avec des personnes physiques ou morales, y compris leurs filiales ou établissements ou toute autre entité, domiciliées, enregistrées ou établies dans un Etat ou un territoire figurant sur les listes publiées par le GAFI parmi ceux dont la législation ou les pratiques font obstacle à la LCB-FT ou par la Commission européenne en application de l'article 9 de la directive (UE) 2015/849 du 20 mai 2015 relative à la prévention de l'utilisation du système financier aux fins du blanchiment de capitaux ou du financement du terrorisme (art. L561-10 du CMF)."
                    />
                  </div>
                  <div class="col-xs-12 col-md-6 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="fondPaysGafi"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Fond provenant d’un pays liste GAFI"
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Fonds en provenance ou à destination d'un Etat ou un territoire figurant sur les listes publiées par le GAFI parmi ceux dont la législation ou les pratiques font obstacle à la LCB-FT ou par la Commission européenne en application de l'article 9 de la directive (UE) 2015/849 du 20 mai 2015 relative à la prévention de l'utilisation du système financier aux fins du blanchiment de capitaux ou du financement du terrorisme."
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-6 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="operationPaysNonCooperatif"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Opération avec pays non coopératif"
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Personnes physiques établies ou situées dans un pays non coopératif en matière fiscale selon  l’article 238-0 A du CGI."
                    />
                  </div>
                  <div class="col-xs-12 col-md-6 d-flex gap-1">
                    <div class="element-disabled">
                      <pr-input-radio
                        formControlName="fondPaysNonCooperatif"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Fond provenant d’un pays non coopératif "
                      >
                      </pr-input-radio>
                    </div>
                    <pr-tooltip-icon
                      tooltip="Fonds en provenance ou à destination d'un pays non coopératif en matière fiscale selon l’article 238-0 A du CGI."
                    />
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </ng-container>
        </mat-step>
      }
    </mat-stepper>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
